<template>
  <div class="courseDetail noSel">
	  <div class="cont">
     <div class="mian">
		<div class="berLi">
			<div class="ber" @click="goLinks('course')">
				课程列表
			</div>
			<div class="ber">
				>
			</div>
			<div class="ber avts">
				{{info.title}}
			</div>
		</div>
			<div class="playBanner">
				<div class="left">
					<img v-if="info.coverPic" :src="info.coverPic" >
					<img v-else src="../../../assets/images/course/paly.png" >
				</div>
				<div class="right">
					<div class="name">
						{{info.title}}
					</div>
					<div class="devLi">
						<div class="li">
							{{info.courseCount}}节课程
						</div>
						<!-- <div class="li">
							{{info.coursewareCount}}个课件
						</div> -->
						<div class="li">
							{{info.learnCount}}人已学习
						</div>
						<div class="li">
							<i class="star" v-for="(item,index) in info.star" :key="'travel'+index"></i><i class="star2" v-for="(items,index) in  status(info.star)" :key="index"></i><em>{{info.star}}.0</em>
						</div>
						<div class="li">
							<div class="lefts" @click.stop="goChenk(info.collection,info.id)">
								<div class="ioc">
								<img :src="info.collection?require('../../../assets/images/course/sc.png'):require('../../../assets/images/course/sc1.png')" alt="">
								</div>
								<div class="de">收藏</div>
							</div>
						</div>
					</div>
					<div class="kl" v-if="info.lecturer">
						<div class="tx">
							<img v-if="info.lecturer.lecturerAvatarUrl" :src="info.lecturer.lecturerAvatarUrl" >
							<img v-else src="../../../assets/images/course/user.svg" >
						</div>
						<div class="kox"  >
							<div class="til">
								{{info.lecturer.lecturerName}}
							</div>
							<div class="tilDev">
               					 {{info.lecturer.lecturerIntroduction}}
							</div>
							<!-- <div class="tilDev">
               					{{info.lecturer.lecturerIntroductionDetail}}
							</div> -->
						</div>
					</div>
					<div class="btWrap" v-if="info.feeType=='free'">
						<div class="but"  @click="goWatch">
							 播放视频
						</div>
						<!-- <div class="but"  @click="isLond=true">
							 下载客户端
						</div> -->
						<div class="acm">
							免费课程
						</div>
					</div>
					<div class="btWrap" v-if="info.feeType=='charge'">
						<div class="but"  @click="isLond=true" v-if="isStation||isCourse">
							 下载客户端
						</div>
						<div class="but"  @click="viewFun"  v-else >
							会员充值
						</div>
						<div class="acm avtrs" >
							会员课程
						</div>
						<!-- <div class="dnm">
							<div class="dlx">
								￥<em>{{info.price}}</em>
							</div>
						</div> -->
					</div>
					<div class="btWrap" v-if="info.feeType=='alone'&&info.oriState==1">
						<div class="but"  @click="isLond=true" >
							 下载客户端
						</div>
						<div class="acm " >
							已购买
						</div>
					</div>
					<div class="btWrap" v-if="info.feeType=='alone'&&info.oriState==2">
						<div class="but"  @click="isLond=true" >
							 下载客户端
						</div>
						<div class="acm " >
							已兑换
						</div>
					</div>
					<div class="btWrap" v-if="info.feeType=='alone'&&info.oriState==0">
						<div class="but alonebut" @click="shopCourse()">
							 购买课程
						</div>
						<div class="aloneCont" >
							<div class="aloneTop" v-if="isStation">
								<div class="vip">
								<img src="../../../assets/images/vip.png" alt="">
								</div>
								<div class="originalPrices">
								￥<span>{{info.price}}</span>
								</div>
								<div class="prices">
								￥<span>{{info.originalPrice}}</span>
								</div>
							</div>
							<div class="aloneTop avt" v-else >
								<div class="original">
								优惠价
								</div>
								<div class="originalPrices">
								￥<span>{{info.price}}</span>
								</div>
								<div class="prices">
								￥<span>{{info.originalPrice}}</span>
								</div>
							</div>
							<div class="alonebottom" v-if="isStation">
								<span>您已享受最高优惠</span>
							</div>
							<div class="alonebottom avts" v-else>
								<div class="vip">
								<img src="../../../assets/images/vip.png" alt="">
								</div>  
								<span>再享折上8.8折</span>
							</div>
						</div>
					</div>
					<!-- <div class="btWrap" v-else>
						<div class="but" style="background-color: #4a9f64; color: #fff; margin-right: 10px;">
							<img src="../../../assets/images/course/LiveIcon.svg" style="width: 18px;height: 18px;vertical-align: middle;margin-right: 8px;margin-top: -3px;" >试看
						</div>
						<div class="but">
							立即购买
						</div>
						<div class="dnm">
							<div class="dlx">
								￥<em>188</em>
							</div>
							<div class="dle">
								￥<em>400</em>
							</div>
						</div>
					</div> -->
				</div>
			</div>
			<div class="contList">
				<div class="playNav">
					<ul>
						<li :class="{avt:indexs==0}" @click="indexs=0">
							课程介绍
						</li>
						<li :class="{avt:indexs==1}" @click="indexs=1;getCourse()">
							课程目录
						</li>
						<li :class="{avt:indexs==2}" @click="indexs=2;">
							评论( <em>{{commentInfo.totalCount}}</em> )
						</li>
					</ul>
				</div>
				<div class="playBox" v-if="indexs==0">
					<div class="title">
						老师介绍
					</div>
					<div class="playCo" v-if="info.lecturer">
						<div class="img">
							<img v-if="info.lecturer.lecturerAvatarUrl" :src="info.lecturer.lecturerAvatarUrl" >
							<img v-else src="../../../assets/images/course/bos.png" >
						</div>
						<div class="right" >
							<div class="na">
								{{info.lecturer.lecturerName}}
							</div>
							<div class="de">
								{{info.lecturer.lecturerIntroduction}}
							</div>
							<div class="de">
								{{info.lecturer.lecturerIntroductionDetail}}
							</div>
						</div>
					</div>
					<div class="title">
						课程介绍
					</div>
					<div class="remk" v-html="info.introduction">
					
					</div>
					<!-- <div class="imgLists">
						<img src="../../../assets/images/course/detail.png" >
					</div>
					<div class="imgLists">
						<img src="../../../assets/images/course/detail.png" >
					</div> -->
				</div>
				<div class="playBox" v-if="indexs==1">
					<dl>
						<!-- <dd class="avt">
							<div class="num">
								01
							</div>
							<div class="icon">
								
							</div>
							<div class="namelv">
								从账号受限案例看账号申诉的思路与方法
							</div>
							<div class="state">
								<span>15分钟</span> ｜ 免费
							</div>
						</dd> -->
						<dd v-for="(item,index) in inDa" :key="index" @click="selectMlLive(item.feeType,item.id,item.url);">
							<div class="num">
								{{index+1}}
							</div>
							<div class="icon">
								
							</div>
							<div class="namelv">
								{{item.title}}
							</div>
							<div class="state">
								<span v-if="item.duration">{{ (item.duration/60).toFixed(0)  ||0}}分钟</span><span v-else>0分钟</span>  ｜ {{item.feeType=='free'?'免费':'付费'}}
							</div>
						</dd>
						<!-- <dd>
							<div class="num">
								03
							</div>
							<div class="icon">
								
							</div>
							<div class="namelv">
								从账号受限案例看账号申诉的思路与方法
							</div>
							<div class="state">
								<span>15分钟</span> ｜ 免费
							</div>
						</dd> -->
					</dl>
				</div>
				<div class="playBox1" v-if="indexs==2">
					<div class="title">
						<div>给个评价把！</div>
						<el-rate
						v-model="sourceCo"
						show-text>
						</el-rate>
					</div>
					<div class="text">
						<textarea name="" id="" cols="30" rows="10" placeholder="写评论...." v-model="cont"></textarea>
					</div>
					<div class="btnWrap">
						<div class="btn"  @click="addPf(0)">提交</div>
						<div class="btn1" @click="addPf(1)">匿名提交</div>
					</div>
					<div class="ul" v-if="commentInfo.list!=''" >
						<div class="li" v-for="(item,index) in commentInfo.list" :key="index">
							<div class="left">
								<div class="icon">
									<img src="../../../assets/images/course/Avatar.png" alt="">
								</div>
							</div>
							<div class="right">
								<div class="adT">
									<div class="name">
										{{item.username}}
									</div>
									<div class="lis"><i class="star" v-for="(items,ide) in item.star" :key="'travel'+ide"></i> <i class="star2" v-for="(item,ide) in status(item.star)" :key="ide"></i></div>
								</div>
								<div class="dev">{{item.content}}</div>
								<div class="date">{{item.createTime}}</div>
							</div>
						</div>
					</div>
					<div class="pageWrap" v-if="commentInfo.list!=''">
						<div class="pages">
						<el-pagination
							:page-size="limit"
							layout="prev, pager, next"
							@current-change="handleCurrentChange"
							:total="commentInfo.totalCount">
						</el-pagination>
						</div>
					</div>
				</div>
				
			</div>
		</div>
	  </div>
	<div class="czTips" v-if="isXsTips">
		<div class="heads">
			会员充值<span @click="isXsTips=false;clearIntervalFun()">×</span>
		</div>
		<div class="czCon">
			<div class="listWrap">
				<div class="codeWrap" v-if="isCode">
					<div class="wxic">
						<img src="../../../assets/images/weix.png" alt="">
						<div class="db">请使用微信扫码支付</div>
					</div>
					<div class="code" id="qrcode" ref="qrCodeUrl">
						<vue-qr :text="downloadData.url" :margin="0" colorDark="#000000" colorLight="#fff" :logoSrc="downloadData.icon" :logoScale="0.1" :size="200"></vue-qr>
					</div>
					<div class="tiWrap">
						<div class="ti">
							交易将在 15分钟后失效，请及时付款！
						</div>
						<div class="ti" style="margin-top:3px;">（失效请重新获取） 
						</div>
					</div>
					<div class="cse">
						<div class="cx">
							<div class="le">请仔细阅读</div>
							<div class="ri" @click="smTipsfun()">
								零距离会员服务协议
							</div>
						</div>
					</div>
				</div>
				<div class="butWrap" v-if="noCode">
					<div class="but" @click="put()">前往充值</div> 
					<div class="cse">
						<div class="cx">
							<div class="le">请仔细阅读</div>
							<div class="ri" @click="smTipsfun()">
								零距离会员服务协议
							</div>
						</div>
					</div>
				</div>
				<!-- <div class="list">
					<div class="left">
						<div class="bo">
							<div class="img">
								<img src="../../../assets/images/vs1.png" alt="">
							</div>
							<div class="na">课程会员</div>
						</div>
					</div>
					<div class="boxs" v-if="dataObj.course">
						<div class="bs" :class="{avt:int==item.id}" @click="slectClick(item.id,item.name)" v-for="(item,index) in dataObj.course" :key="index">
							<div class="tips" v-if="item.extraDay">限时优惠：额外赠送{{item.extraDay}}天</div>
							<div class="originalPrice">
							 原价：<del>{{item.originalPrice}}</del> 
							</div>
							<div class="co">
								<i>{{item.price}}</i><span>元/{{item.remark.substr(2,1)}}</span>
							</div>
							<div class="lsr">
								{{item.name}}
							</div>
							<div class="sls">{{item.remark}}</div>
						</div>
					</div>
				</div> -->
				<!-- <div class="list">
					<div class="left">
						<div class="bo bk">
							<div class="img">
								<img src="../../../assets/images/vs3.png" alt="">
							</div>
							<div class="na">案例会员</div>
						</div>
					</div>
					<div class="boxs" v-if="dataObj.cases">
						<div class="bs" :class="{avt:int==item.id}" @click="slectClick(item.id,item.name)" v-for="(item,index) in dataObj.cases" :key="index">
							<div class="tips">限时优惠：额外赠送{{item.extraDay}}天</div>
							<div class="co">
								<i>{{item.price}}</i><span>元/{{item.remark.substr(2,1)}}</span>
							</div>
							<div class="lsr">
								{{item.name}}
							</div>
							<div class="sls">{{item.remark}}</div>
						</div>
					</div>
				</div> -->
				<div class="munberList" v-if="dataObj">
					<div class="List" :class="{avt:int==item.id}" @click="slectClick(item.id,item.name)" v-for="(item,index) in dataObj" :key="index">
					<div class="hea">
						<div class="left">
						{{statusTwo(item.auth) }}
						</div>
						<div class="right">
						{{statusYers(item.duration)}}
						</div>
					</div>
					<div class="borderCo"></div>
					<div class="bottmunber">
						<div class="le">
						<div class="price"><div class="pl">￥</div><div class="pr">{{item.price}}</div></div>
						<div class="prices"><div class="pl">￥</div><div class="pr">{{item.originalPrice}}</div></div>
						</div>
						<div class="ri">
						{{item.remark}}
						</div>
					</div>
					</div>
				</div>
			</div>
		</div>
	</div>
    <div class="pop_bg"  v-if="isLive"></div>
    <div class="scorePop" v-show="isLive">
      <div class="head">
        <div class="left" v-if="liveObj">第{{liveObj.id}}节：{{liveObj.title}}</div>
        <div class="right" v-if="liveObj">{{info.learnCount}}人学习 <span>{{liveObj.feeType=='free'?'免费':'付费'}}</span></div>
        <div class="ico" @click="gbWatch()">
          ×
        </div>
      </div>
	  <div class="con">
		  <div class="live" v-if="videoShow">
			  <video
			id="myVideo"
			class="video-js"
			>
			<source type= 'video/mp4'
			:src='videoUrl'
			>
			</video>
		  </div>
		  <div class="liWrap">
			  <div class="has">
				  课程目录
			  </div>
			  <div class="coUl">
				  <div class="coLi" v-for="(item,index) in inDa" :key="index" :class="{avt:liveIndex==index}" @click="selectLive(index,item.id);recordCourseLearnNum()">
					  <div class="name">
						  第{{index+1}}节：{{item.title}}
					  </div>
					  <div class="time" v-if="item.duration">{{ secondsFormat(item.duration) ||'00:00:00'}}</div>
					  <div class="time" v-else>00:00:00</div>
				  </div>
				  <!-- <div class="coLi">
					  <div class="name">
						  第二节：产品上传
					  </div>
					  <div class="time">00:15:00</div>
				  </div> -->
			  </div>
		  </div>
	  </div>
    </div>
	<Downloads :isLond="isLond" :londFun="londFun"></Downloads>
  </div>
</template>
<script>
import vueQr from 'vue-qr'
import Downloads from '../../../components/Downloads/Index'
export default {
  name: "courseDetail",
  data: function() {
    return {
		isLond:false,
		isCode:false,
		noCode:true,
		isXsTips:false,
		indexs:0,
		info:{},
		inDa:[],
		int:1,
		dataObj:[],
		liveIndex:0,
		cont:'',
		type:'',
		myPlayer:null,
		page:1,
		videoShow:false,
		sourceCo:5,
		isLive:false,
		limit:10,
		pre:'',
		liveObj:{},
		commentInfo:{},
		videoUrl:'',
		orderId:'',
		timeInterval:null,
		isStation:false,
		isCourse:false,
		memberList:[],
		downloadData: {
			url: '',
			icon: require("../../../assets/images/logoCode.png")
        },
		videoObj:{
		//确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
		controls: true,
		//自动播放属性,muted:静音播放
		autoplay: "Player",
		//建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
		preload: "auto",
		//设置视频播放器的显示宽度（以像素为单位）
		width: "800px",
		//设置视频播放器的显示高度（以像素为单位）
		height: "400px",
		poster:'',
		}
    }
  },
  created(){
	this.getmember()
    this.getDetail()
	this.getComment()
	this.getCourse()
	this.getGoods()

  },
  mounted () {
  },
  computed: {
    user() {
      return this.$store.getters.user;
	},
	statusTwo(v) {
      return function (v) {
          switch (v) {
            case 'STATION':
              return  "vip会员"
            case 'COURSE':
              return "课程会员"
            case 'CASE':
              return "案例会员"
          }
      }
    },
    statusYers(v) {
      return function (v) {
          switch (v) {
            case 30:
              return  "月卡"
            case 90:
              return "季卡"
            case 365:
              return "年卡"
          }
      }
    },
	status(v) {
        return function (v) {
		   if(v){
			  switch (v) {
				case 0:
					return 5
				case 1:
					return 4
				case 2:
					return 3
				case 3:
					return 2
				case 4:
					return 1
				case 5:
					return 0
				}
		   }else{
			 return 0  
		   }
        }
    }
  },
  components: {
	  vueQr,
	  Downloads  
  },
  methods: {
	  shopCourse(){
		  if(!this.user.username){
             this.$store.dispatch("loginState",{isShowLogin:true}); 
            return
	       }
		  this.goLinks('/odInfo?id='+this.info.id)
	  },
	  londFun(e){
       this.isLond= e
     },
	viewFun(){
		if(!this.user.username){
             this.$store.dispatch("loginState",{isShowLogin:true}); 
            return
        }
		this.isXsTips=true;
		// this.goWatch();
		// this.recordCourseLearnNum()
	},
	smTipsfun(){
		  window.open(this.interfaceJson.ipUrl+'/number.html')
	},
	slectClick(e,name){
		window.clearInterval(this.timeInterval);
		this.int=e;
		this.noCode=true;
		this.isCode=false;
	},
	getGoods(){
      this.$axios
      .get(this.interfaceJson.serverAddress+'/api/pay/goods')
      .then(res => {
        let data=res.data;
        if(data.code==0){
          if(data.data){
			this.dataObj=data.data
			this.slectClick(this.dataObj[0].id,this.dataObj[0].name)
          }else{
            this.dataObj=[]
          }
        }
      });
	},
	put(){
		this.isCode=true
		this.noCode=false
		  this.$axios
				.post(this.interfaceJson.serverAddress+'/api/pay/create/'+this.int)
				.then(res => {
				let data=res.data;
				if(data.code==0){
					window.clearInterval(this.timeInterval)
					this.downloadData.url=data.data
					this.orderId=data.orderId
				    this.timeInterval=	setInterval(() => {
						this.query()	
					}, 3000);
				}
			});	
	  },
	  getmember(){
		this.$axios
		.get(this.interfaceJson.serverAddress+'/api/user/member')
		.then(res => {
			let data=res.data;
			if(data.code==0){
				this.memberList=data.data
				if(this.memberList.length!=0){
					this.memberList.forEach((item,i)=>{
						if(item.auth=="STATION"){
							this.isStation=true
						}
						if(item.auth=="COURSE"){
							this.isCourse=true
						}
						if(item.auth=="CASE"){
							this.isCase=true
						}
					})
				}
			}
		});
	  },
	  query(){
		  this.$axios
		  .get(this.interfaceJson.serverAddress+'/api/pay/query/'+this.orderId)
		.then(res => {
			let data=res.data;
			if(data.code==0){
				if(data.data){
					window.clearInterval(this.timeInterval)
					this.timeInterval=null
					// this.isCode=false
					this.$message({
						message: "充值成功",
						duration: 1000,
						type: "success"
					});
					this.$store.dispatch("loginState",{isManber:true}); 
					this.isXsTips=false;
					this.isCode=false
					this.noCode=true
					location.reload();
					this.getDetail()
				}
				
			}
		});
	  },
	getVideoUrl(e){
		if(this.user.member){
            this.$axios
			.get(this.interfaceJson.serverAddress+"/api/play/acceptPlayUrl/"+ this.liveObj.resourceId+'?columnId='+this.$route.query.id)
				.then(res => {
				let data=res.data;
					if(data.code==0){
					this.videoUrl=data.data.path
					if(e=='lode'){
						this.lodeVideo()
					}
				}
			})
        }
		
		
	},
	goChenk(e,id){
	let url=''
	if(e){
		url= '/api/course/unCollection/'
	}else{
		url= '/api/course/collection/'
	}
	this.$axios
		.post(this.interfaceJson.serverAddress+url+id)
		.then(res => {
		let data=res.data;
		if(data.code==0){
		this.getDetail()
		}else{
		}
		});
    },
	goWatch(){
		if(this.isStation||this.isCourse){
			if(this.liveObj.feeType=="free"){
			// 	this.$message({
            //     message: "请下载客户端",
            //     type: "error"
			// }); 
				window.open(this.pre+this.liveObj.url,true)  
		   }else{
			this.$message({
                message: "请下载客户端",
                type: "error"
			}); 
		   }
        //   if(this.liveObj){
		// 		this.isLive=true
		// 		this.initVideo()
		// 		this.videoShow=true;
		// 	}else{
		// 		this.$message({
		// 			message: "暂无视频播放",
		// 			type: "error"
		// 		});
		// 	}
		// this.endVideo()
		// var vide=document.getElementById("myVideo_html5_api");
		// 	vide.play();
        }else{
          	if(this.info.feeType=='free')
			{
			// 	this.$message({
            //     message: "请下载客户端",
            //     type: "error"
			// }); 
				window.open(this.pre+this.liveObj.url,true) 	 
			}else{
				this.$message({
					message: "目前仅开放指定会员或者付费观看！",
					type: "error"
				});
			}
        }
	},
	gbWatch(){
		this.isLive=false;
		this.videoShow=false;
		this.endVideo()
	},
	initVideo() {
	//初始化视频方法
	this.videoShow=true;
	 setTimeout(() => {
          this.myPlayer = this.$video(myVideo ,this.videoObj) //点击初始化video控件
        }, 1000)
	},
	endVideo() {
	//初始化视频方法
		 var vide=document.getElementById("myVideo_html5_api");
		 vide.pause();
	},
	selectMlLive(e,id,url){
		if(this.isStation||this.isCourse){
			if(e=="free"){
			// 	this.$message({
            //     message: "请下载客户端",
            //     type: "error"
			// }); 
				window.open(this.pre+url,true)  
		   }else{
			this.$message({
                message: "请下载客户端",
                type: "error"
			}); 
		   }
			// this.getVideoUrl()
        }else{
			if(this.info.feeType=='free')
			{
			// 	this.$message({
            //     message: "请下载客户端",
            //     type: "error"
			// }); 
				window.open(this.pre+url,true) 	 
			}else{
				this.$message({
					message: "目前仅开放指定会员或者付费观看！",
					type: "error"
				});
			}
          	
        }
	},
	selectLive(e,id){
		if(this.user.member){
            // console.log(e+"+"+id);
			this.isLive=true;
			this.initVideo();
			this.videoShow=true;
			this.liveIndex=e
			this.liveObj= this.inDa.filter(item => item.id==id)[0]
			// this.myPlayer.dispose() //销毁播放器
			this.getVideoUrl('lode')
        }else{
          	 this.$message({
                message: "目前仅开放指定会员观看！",
                type: "error"
            });
        }
		
	},  
	close() {
	this.myPlayer.dispose() //销毁播放器
	},
	lodeVideo(){
		try {
			var video = document.getElementsByTagName('video')[0];
			var sources = video.getElementsByTagName('source');
			sources[0].src =this.videoUrl;
			video.load();
		}
		catch (e) {
		}
	},
	handleCurrentChange(val){
		this.page=val
        this.getComment()
	},
	addPf(e){
		if(!this.cont){
			this.$message({
				message: "请输入评论内容！",
				type: "error"
				});
			return
		}
		this.$axios
			.post(this.interfaceJson.serverAddress+"/api/course/commitComment",{
				commitType:e,
				content:this.cont,
				userId:this.user.id,
				star:this.sourceCo,
				courseColumnId:this.$route.query.id,
				username:this.user.username
				
			})
			.then(res => {
			let data=res.data;
			if(data.code==0){
				this.cont=''
				this.getComment()
			}else{
				
			}
		});
		
	},
	recordCourseLearnNum(){
		this.$axios
			.post(this.interfaceJson.serverAddress+"/api/course/recordCourseLearnNum/"+this.$route.query.id)
			.then(res => {
			let data=res.data;
			if(data.code==0){
			}else{
				
			}
		});
	},
		// 秒转时分秒
	secondsFormat( s ) { 
		if(s=='') return;
		var day = Math.floor( s/ (24*3600) ); // Math.floor()向下取整 
		var hour = Math.floor( (s - day*24*3600) / 3600); 
		var minute = Math.floor( (s - day*24*3600 - hour*3600) /60 ); 
		var second = s - day*24*3600 - hour*3600 - minute*60; 
		return  hour + ":" + minute + ":" + second ; 
	},
	getComment(){
 		this.$axios
        .get(this.interfaceJson.serverAddress+"/api/course/comment/"+this.$route.query.id+'?page='+this.page+'&limit='+this.limit)
        .then(res => {
        let data=res.data;
        if(data.code==0){
		  this.commentInfo=data.data
        }
      })
	},
    getDetail(){
      this.$axios
        .get(this.interfaceJson.serverAddress+"/api/course/detail/"+this.$route.query.id)
        .then(res => {
        let data=res.data;
        if(data.code==0){
		  this.info=data.data
        }
      });
	},
    getCourse(){
       this.$axios
        .get(this.interfaceJson.serverAddress+"/api/course/catalogue/"+this.$route.query.id)
        .then(res => {
        let data=res.data;
        if(data.code==0){
		  this.inDa=data.data
		  this.pre=data.pre
		  if(this.inDa){
			    this.liveObj= this.inDa[0]
		   		this.getVideoUrl()
		  }
        }
      });
	},
	clearIntervalFun(){
		window.clearInterval(this.timeInterval)
	}
  },
	beforeDestroy () {
		window.clearInterval(this.timeInterval)
	},
  
};
</script>
<style lang="scss" scoped>
.munberList{
	display: flex;
	width: 715px;
	// margin: 35px auto 0;
	.List{
		background: url('../../../assets/images/menberBg.png') no-repeat;
		width: 245px;
		height: 127px;
		background-size: 100%;
		padding-top: 20px;
		cursor: pointer;
		box-sizing: border-box;
		margin: 15px;
		.hea{
			margin: 0 auto 0;
			// padding: 0 10px 0 10px;
			width: 180px;
			display: flex;
			box-sizing: border-box;
			justify-content: space-between;
			.left{
				font-size: 13px;
				font-family: Source Han Serif CN;
				font-weight: bold;
				color: #F0D18F;
			}
			.right{
				font-size: 15px;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #CBA95C;

			}
		}
		.borderCo{
			width: 173px;
			border: 1px solid #CBA95C;
			opacity: 0.2;
			margin-left: 13px;
			margin-top: 11px;
		}
		.bottmunber{
			// justify-content: space-between;
			// display: flex;
			height: 19px;
			width: 173px;
			margin:13px auto 0;
			.le{
				display: flex;
				.price{
					display: flex;
					.pl{
						font-size: 12px;
						font-family: Arial;
						font-weight: 400;
						color: #CBA95C;
						line-height: 26px;
					}
					.pr{
						font-size: 19px;
						font-family: Arial;
						font-weight: 400;
						color: #CBA95C;
					}
				}
				.prices{
					margin-left: 4px;
					display: flex;
					text-decoration:line-through;
					color: #999999;
					.pl{
						font-size: 12px;
						font-family: Arial;
						font-weight: 400;
						color: #999999;
						line-height: 24px;
					}
					.pr{
						font-size: 12px;
						font-family: Arial;
						font-weight: 400;
						color: #999999;
						line-height: 24px;
					}
				}
			}
			.ri{
				text-align: right;
				font-size: 12px;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #999999;
				line-height: 23px;
			}
		}
	}
	.avt{
		box-shadow: 0px 0px 29px 0px #CBA95C;
		border: 2px solid #CBA95C;
		box-sizing: border-box;
		border-radius: 12px;
	}
}
.originalPrice{
	position: absolute;
    right: 9px;
    top: 5px;
    font-size: 12px;
    color: #999;
}
.cse{
	margin-top:10px;
	.cx{
		text-align: center;
		.le{
			display: inline-block;
			height: 14px;
			font-size: 14px;
			font-weight: 400;
			color: #333333;
			line-height: 14px;
		}
		.ri{
			display: inline-block;
			margin-left: 5px;
			line-height: 14px;
			font-size: 12px;
			color: #172FC3;
			cursor: pointer;
			text-decoration:underline;
		}
	}

	}
.butWrap{
	position: absolute;
	right: 40px;
	bottom: 29px;
	.but{
		width: 120px;
		height: 26px;
		background: #FBCA61;
		border-radius: 13px;
		font-size: 12px;
		cursor: pointer;
		text-align: center;
		color: #fff;
		margin: 0 auto;
		line-height: 26px;
	}
	// .but:hover{
		
	// }	
}
.codeWrap{
	position: absolute;
	right: 28px;
    top: -29px;
	.wxic{
		margin-top: 20px;
		display: flex;
		text-align: center;
		line-height: 20px;
		justify-content: center;
		.db{
			font-size: 14px;
			color: #3B3B3B;
			margin-left: 5px;
		}
	}
	.code{
		width: 150px;
		height: 150px;
		background: #DFDFDF;
		margin: 22px auto 0;
	}
	.tiWrap{
		margin-top: 20px;
		.ti{
			color: #FF0000;
			text-align: center;
			font-size: 12px;
			margin: 0 auto;
		}
	}
}

.czTips{
	position: fixed;
	background-color: #fff;
	left: 50%;
	top: 50%;
	 z-index: 9999999;
	transform: translate(-50%, -50%);    /* 50%为自身尺寸的一半 */
	border-radius: 2px;
	width:980px;
	height:386px;
	box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1);
	.heads{
		width: 980px;
		height: 41px;
		background: #FBCA61;
		color: #fff;
		font-size: 14px;
		line-height: 41px;
		padding-left: 20px;
		box-sizing: border-box;
		border-radius: 2px 2px 0px 0px;
		position: relative;
    	box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1);
		span{
			position: absolute;
			right: 25px;
			font-size: 17px;
			cursor: pointer;
		}
	}
	.czCon{
		height: 386px;
	}
}
.listWrap{
	margin-top: 54px;
	padding-left: 49px;
	position: relative;
	.list{
		display: flex;
		align-items: center;
		margin-bottom: 29px;
		.left{
			width: 70px;
			margin-left: 8px;
			.bo{
				width: 70px;
				height: 70px;
				border-radius:50%;
				background: #FFF9EC;
				text-align: center;
				.img{
					width: 22px;
					height: 17px;
					margin: 0 auto ;
					padding-top: 19px;
					img{
						width: 100%;
					}
				}
				.na{
					margin-top: 3px;
					font-size: 12px;
					font-family: Microsoft YaHei;
					font-weight: 400;
					color: #666666;
				}
			}
			.bk{
				background: #FFF3FB;
			}
			.bgs{
				background: #EFFBFC;
			}
		}
		.boxs{
			margin-left: 28px;
			display: flex;
			flex-wrap: wrap;
			.bs{
				cursor: pointer;
				width: 174px;
				height: 104px;
				border: 1px solid #E7E7E7;
				border-radius: 6px;
				position: relative;
				margin-right: 21px;
				margin-bottom: 21px;
				.tips{
					position: absolute;
					top: -9px;
					left: -11PX;
					width: 140px;
					height: 20px;
					background: linear-gradient(153deg, #FF7F40, #FFA200);
					border-radius: 6px 0px 6px 0px;
					text-align: center;
					line-height: 20px;
					font-size: 10px;
					font-family: Microsoft YaHei;
					font-weight: 400;
					color: #FFFFFF;
				}
				.co{
					text-align: center;
					margin-top: 30px;
					height: 30px;
					line-height: 30px;
					i{
						font-size: 30px;
						font-family: Microsoft YaHei;
						font-weight: 400;
						font-style: italic;
						color: #FBCA61;
						// line-height: 32px;
					}
					span{
						font-size: 10px;
						font-family: Microsoft YaHei;
						font-weight: 400;
						color: #FBCA61;
					}
				}
				.lsr{
					text-align: center;
					font-size: 10px;
					font-family: Microsoft YaHei;
					font-weight: 400;
					color: #666666;
					margin-top: 4px;
				}
				.sls{
					position: absolute;
					left: 10px;
					bottom: 6px;
					font-size: 10px;
					font-family: Microsoft YaHei;
					font-weight: 400;
					color: #666666;
				}
			}
			.avt{
				border: 1px solid #FBCA61;
				position: relative;
			}
			.avt::after{
				content: "";
				width: 27px;
				height: 27px;
				background:url("../../../assets/images/select.png");
				position: absolute;
				right: 0;
				bottom: -1px;
			}
		}
	}
}
.pop_bg{
	width: 100%;
    left: 0px;
    top: 0px;
    height: 100%;
    position: fixed;
/*    user-select: none; */
    z-index: 99;
	background-color: #000;
    opacity: .5;
}
.scorePop{
  	position: fixed;
    left: 50%;
    top: 50%;
    z-index: 999;
    background-color: #fff;
    transform: translate(-50%, -50%);
    width: 1124px;
    height:526px;
    box-sizing: border-box;
    // padding:0 23px 0 23px;
	.head{
		display: flex;
		height: 36px;
		background: #333333;
		position: relative;
		justify-content: space-between;
		.left{
			font-size: 12px;
			color: #FFFFFF;
			margin-left: 20px;
			line-height: 36px;
		}
		.right{
			color: #FFFFFF;
			font-size: 12px;
			line-height: 36px;
			margin-right: 254px;
			span{
				margin-left: 15px;
				color: #4A9F64;
			}
		}
		.ico{
			position: absolute;
			right: 15px;
			top: 8px;
			color: #FFFFFF;
			opacity: 1;
			cursor: pointer;
			font-size: 22px;
			border-radius: 1px;
		}
	}
	.con{
		display: flex;
		.live{
			width: 870px;
			height: 490px;
		}	
		.liWrap{
			background-color: #171618;
			width: 254px;
			.has{
				width: 207px;
				height: 24px;
				background: #F3CD70;
				opacity: 1;
				color: #171618;
				font-size: 12px;
				border-radius: 12px;
				text-align: center;
				line-height: 24px;
				margin:21px auto 24px;
			}
			.coUl{
				width: 235px;
				margin:0 auto;
				border-top:1px solid #333333;
				padding-top: 13px;
				.coLi{
					margin-bottom: 10px;
					width: 235px;
					padding:2px 21px 2px 21px;
					box-sizing: border-box;
					cursor: pointer;
					.name{
						color: #FFFFFF;
						font-size: 12px;
					}
					.time{
						color: #FFFFFF;
						font-size: 12px;
						margin-top: 16px;
					}
				}
				.avt{
					background-color: #5D5C5E;
				}
			}
		}
	}
}
.courseDetail .cont{
  max-width: 1380px;
  margin: 0 auto;
}
.playBanner {
	display: flex;
	width: 100%;
	height: 330px;
}
.playBanner .left{
	width: 508px;
	height: 330px;
	img{
		width: 508px;
		height: 330px;
	}
}
.playBanner .right{
	width: 902px;
	height: 330px;
	// background-color: #333333;
	box-sizing: border-box;
	padding-left: 41px;
	padding-top: 58px;
}
.playBanner .right .name{
	color: #333333;
	font-size: 24px;
	height: 33px;
	line-height: 33px;
}
.playBanner .right .devLi{
	display: flex;
	margin-top: 13px;
}
.playBanner .right .devLi .li{
	height: 15px;
	line-height: 15px;
	color: #868687;
	font-size: 12px;
	padding-right: 20px;
	border-right: 1px solid #868687;
	margin-right: 15px;
}
.playBanner .right .devLi .li:last-of-type{
	border-right:0;
}
.playBanner .right .devLi .li .star{
	width: 12px;
	height: 12px;
	background: url('../../../assets/images/course/sc.png')no-repeat;
	background-size: 12px;
	display: inline-block;
	margin-right: 3px;
	margin-top: -3px;
	vertical-align: middle;
}
.playBanner .right .devLi .li .lefts{
	display: flex;
	cursor: pointer;
	.ioc{
	line-height: 17px;
	img{
		width: 11px;
		height: 11px;
	}
	}
	.de{
	color: #666666;
	font-size: 12px;
	line-height: 17px;
	margin-left: 3px;
	}
}
.playBanner .right .devLi .li .star2{
	width: 12px;
	height: 12px;
	background: url('../../../assets/images/course/sc1.png')no-repeat;
	background-size: 12px;
	display: inline-block;
	margin-right: 3px;
	margin-top: -3px;
	vertical-align: middle;
}
.playBanner .right .devLi .li em{
	font-size: 12px;
	color: #868687;
}
.crumbs{
	padding-left: 24px;
	line-height: 71px;
	background-color: #ffffff;
}
.crumbs span{
	font-size: 14px;
	color: #929193;
}
.crumbs .actives{
	color: #178aff;
}
.kl{
	display: flex;
	margin-top: 28px;
}
.kl .tx{
	width: 36px;
	height: 36px;
	background: #178AFF;
	border-radius: 50%;
	margin-right: 16px;
}
.kl .tx img{
	width: 100%;
	height: 100%;
	border-radius: 50%;
}
.kl .kox{
	width: 550px;
}
.kl .kox .til{
	font-size: 12px;
	line-height: 17px;
	color: #333333;
}
.kl .kox .tilDev{
	color: #929193;
	font-size: 12px;
	margin-top: 5px;
}

.btWrap .but{
	width: 123px;
	height: 40px;
	background-color: #f3cd70;
	border-radius: 2px;
	text-align: center;
	cursor: pointer;
	line-height: 40px;
}
.btWrap .acm{
	color: #4a9f64;
	line-height: 40px;
	margin-left: 20px;
	font-size: 16px;
}
.btWrap .avtrs{
	color: #BD8D63 !important;;
}
.btWrap {
	display: flex;
	height: 40px;
	margin-top: 37px;
	align-items: center;
	 .aloneCont{
		 margin-left: 22px;
		.aloneTop{
			display: flex;
			height: 17px;
			align-items: center;
			margin-bottom: 5px;
			.vip{
			width: 40px;
			height: 12px;
			background-color: #000;
			border-radius: 25px;
			text-align: center;
			img{
				vertical-align: top;
				width: 30.5px;
				height: 8px;
				margin-top: 2px;
			}
			}
			.originalPrices{
			font-size: 12px;
			color: #CBA95C;
			span{
				font-size: 16px;
				color: #CBA95C;
			}
			}
			.prices{
				font-size: 12px;
				color: #999999;
				text-decoration:line-through
			}
		}
		.avt{
			.original{
			color: #333333;
			font-size: 13px;
			}
			.originalPrices{
			font-size: 12px;
			color: #F40101;
			span{
				font-size: 16px;
				color: #F40101;
			}
			}
		}
		.alonebottom{
			display: flex;
			height: 12px;
			line-height: 12px;
			text-align: right;
			justify-content: flex-end;
			span{
				color: #333333;
				font-size: 12px;
				text-align: right;
			}
		}
		.avts{
			.vip{
			width: 40px;
			height: 12px;
			background-color: #000;
			border-radius: 25px;
			text-align: center;
			img{
				vertical-align: top;
				width: 30.5px;
				height: 8px;
				margin-top: 2px;
			}
			}
			span{
				margin-left: 3px;
				color: #CBA95C;
				font-size: 12px;
				text-align: right;
			}
		}
		}
	.alonebut{
		width:120px;
		height: 30px;
		background: #FBCA61;
		border-radius: 15px;
		line-height: 30px;
	}	
}
.contList{
	margin: 0 auto;
	width: 1102px;
}
.playNav {
	width: 100%;
	height: 48px;
	border-bottom: 1px solid #e1e1e2;
}
.playNav ul{
	display: flex;
}
.playNav ul{
	line-height: 48px;
}
.playNav ul li{
	min-width: 56px;
	font-size: 12px;
	color: #929193;
	text-align: center;
	margin-right: 40px;
	cursor: pointer;
}
.playNav ul li em{
	color: #929193;
	vertical-align: middle;
}
.playNav ul .avt{
	color: #333333;
	position: relative;
}
.playNav ul .avt em{
	color: #333333;
}
.playNav ul .avt::before{
	content: "";
	height: 1px;
	width: 100%;
	position: absolute;
	left: 0;
	bottom: 1px;
	background-color: #178AFF;
}
.playBox .title{
	height: 77px;
	line-height: 77px;
	font-size: 18px;
	color: #333333;
}
.playCo{
	display: flex;
	border-bottom: 1px solid #e1e1e2;
	padding-bottom: 37px;
}   
.playCo .img img{
	max-width: 254px;
}
.playCo .img{
	margin-right: 47px;
}
.playCo .right .na{
	font-size: 18px;
	color: #333333;
	margin-top: 33px;
}
.playCo .right .de{
	font-size: 12px;
	color: #666666;
	line-height: 17px;
	margin-top: 26px;
}
.playBox  .remk{
	font-size: 12px;
	line-height:17px;
	color: #333333;
}
.playBox  .remk img{
	max-width: 806px;
}
.playBox {
	padding-bottom: 50px;
}
.playBox .imgLists{
	margin-top: 10px;
}
.playBox .imgLists img{
	width: 806px;
}
.playBox dl dd{
	display: flex;
	height: 60px;
	cursor: pointer;
	position: relative;
	line-height: 60px;
	border-bottom: 1px solid #e1e1e2;
	padding-left: 18px;
	width: 100%;
	box-sizing: border-box;
	align-items: center;
	background-color: #ffffff;
}
.playBox dl .avt{
	background-color: #eeedee;
}
.playBox dl dd .num{
	font-size: 16px;
	color: #929193;
	margin-right: 19px;
}
.playBox dl dd .icon{
	width: 18px;
	height: 18px;
	background: url('../../../assets/images/course/playa.svg') no-repeat;
	background-size: 18px 17px;
	margin-right: 8px;
	
}
.playBox dl .avt .icon{
	background: url('../../../assets/images/course/playb.svg') no-repeat;
	background-size: 18px 17px;
}
.playBox dl dd .namelv {
	font-size: 16px;
	color: #333333;
	width: 520px;
	overflow: hidden;
}
.playBox dl dd  .state{
	position: absolute;
	right: 30px;
	top: 0;
	color: #929193;
	font-size: 12px;
}
.playBox dl dd .state span{
	color: #929193;
	font-size: 12px;
}
.playBox1{
	.title{
		font-size: 16px;
		font-weight: bold;
		line-height:22px;
		color: #333333;
		margin-top: 20px;
		display: flex;
	}
	.text{
		margin-top: 10px;
		textarea{
			width: 1067px;
			height: 100px;
			background: #FFFFFF;
			border: 1px solid #E8E8E8;
			border-radius: 4px;
			resize: none;
			outline: none;
			padding: 10px;
			box-sizing: border-box;
		}
		
	}
	.btnWrap{
		display: flex;
		width: 1067px;
		justify-content: flex-end;
		margin-top: 18px;
		margin-bottom: 24px;
		.btn{
			width: 97px;
			height: 30px;
			background: #F3CD70;
			opacity: 1;
			line-height: 30px;
			text-align: center;
			border-radius: 4px;
			cursor: pointer;
		}
		.btn1{
			width: 97px;
			line-height: 30px;
			text-align: center;
			margin-left: 30px;
			height: 30px;
			border: 1px solid #E1E1E2;
			opacity: 1;
			border-radius: 4px;
			cursor: pointer;
		}
	}
	.ul{
		padding:0px 0 7px 0;
		.li{
			width: 806px;
			padding: 19px 0 17px 0;
			display: flex;
			border-bottom: 1px solid #E1E1E2;
			margin-bottom: 20px;
			.left{
				.icon{
					img{
						width: 53px;
						height: 53px;
					}
				}
			}
			.right{
				margin-left: 14px;
				.adT{
					display: flex;
					.name{
						font-size: 16px;
						font-weight: bold;
						line-height:22px;
						color: #333333;
					}
					.lis{
						margin-left: 14px;
						line-height:22px;
						.star{
							width: 12px;
							height: 12px;
							background: url('../../../assets/images/course/sc.png')no-repeat;
							background-size: 12px;
							display: inline-block;
							margin-right: 3px;
							margin-top: -3px;
							vertical-align: middle;
							margin-right: 4px;
						}
						.star2{
							width: 12px;
							height: 12px;
							background: url('../../../assets/images/course/sc1.png')no-repeat;
							background-size: 12px;
							display: inline-block;
							margin-right: 3px;
							margin-top: -3px;
							vertical-align: middle;
							margin-right: 4px;
						}
					}
					
				}
				.dev{
					font-size: 16px;
					line-height:22px;
					color:#57616C;
					margin-top: 11px;
				}
				.date{
					font-size: 16px;
					line-height:22px;
					color:#999999;
					margin-top: 8px;
				}
			}
			
		}
	}
	.pageWrap{
      text-align: center;
      margin-bottom: 20px;
      .pages{
        display: inline-block;
      }
    }
}
.btWrap .dnm {
	display: flex;
	margin-left: 8px;
}
.btWrap .dlx{
	font-size: 16px;
	line-height: 40px;
	color: #666;
	 text-decoration: line-through;
	
}
.btWrap .dlx em{
	color: #666;
}
.btWrap .dle{
	font-size: 16px;
	line-height: 40px;
	color: #929193;
	margin-left: 7px;
	text-decoration: line-through;
	
}
.btWrap .dle em{
	color: #929193;
}
#myVideo{
	width: 100%;
    height: 100%;
    left: 0;
    top: 0;
}
video{
	outline: none;
}
.berLi{
	display: flex;
	.ber{
		color: #929193;
		padding: 27px 0 21px 0;
		line-height: 20px;
		font-size: 14px;
		margin-left: 9px;
		cursor: pointer;
	}
	.avts{
		color: #178AFF;
	}
}
#qrcode{
	border: 1px solid #e1e1e2;
	width: 150px;
	height: 150px;
	box-sizing: border-box;
}	
#qrcode img{
	width: 150px;
	height: 150px;
}
[v-cloak]{
	display:none;
}
#qrcode canvas{
	width: 233px;
	height: 233px;
}
</style>
<style >
.video-js .vjs-big-play-button{
	top: 50% !important;
    left: 50% !important;
    padding: 0;
    transform: translate(-50%, -50%);
}
</style>
